<template>
  <div class="ball-box" id="div1">
    <a @click="keywords('一揽子政策')">一揽子政策</a>
    <a @click="keywords('财政政策')">财政政策</a>
    <a @click="keywords('货币金融政策')">货币金融政策</a>
    <a @click="keywords('稳投资')">稳投资</a>
    <a @click="keywords('促消费')">促消费</a>
    <a @click="keywords('稳外贸外资')">稳外贸外资</a>
    <a @click="keywords('粮食能源安全')">粮食能源安全</a>
    <a @click="keywords('产业链供应链')">产业链供应链</a>
    <a @click="keywords('保基本民生')">保基本民生</a>
    <a @click="keywords('工业经济大盘')">工业经济大盘</a>
    <a @click="keywords('农业经济发展')">农业经济发展</a>
    <a @click="keywords('房地产业发展')">房地产业发展</a>
    <a @click="keywords('文旅产业发展')">文旅产业发展</a>
    <a @click="keywords('交通运输发展')">交通运输发展</a>
    <a @click="keywords('企业用地政策')">企业用地政策</a>
    <a @click="keywords('环保政策')">环保政策</a>
    <a @click="keywords('科技支持全省经济')">科技支持全省经济</a>
    <a @click="keywords('扶持企业上市')">扶持企业上市</a>
    <a @click="keywords('高校毕业生就业')">高校毕业生就业</a>
    <a @click="keywords('法治化营商环境')">法治化营商环境</a>
    <!-- <a>禁放高利贷</a>
    <a>土地流转</a>
    <a>业主权利</a>
    <a>婚前病史坦白</a>
    <a>诉讼时效</a>
    <a>禁止性骚扰</a>
    <a>见义勇为</a>
    <a>隐私权</a>
    <a>男女平等</a>
    <a>自助行为</a>
    <a>单行法</a>
    <a>遗产继承</a> -->
  </div>
</template>

<script>
export default {
  name: 'ball',
  data() {
    return {
      radius: 120,  //半径
      dtr: Math.PI / 180,
      d: 300,
      mcList: [],
      active: true,  //旋转状态
      lasta: 1,
      lastb: 1,
      distr: true,
      tspeed: 2,
      size: 100,

      mouseX: -8,
      mouseY: 8,

      howElliptical: 1,

      aA: null,
      oDiv: null,
      sa: null,
      ca: null,
      sb: null,
      cb: null,
      sc: null,
      cc: null,
    }
  },
  methods: {
    keywords(text) {
      console.log(text);
      this.$emit('ballSearch', text)
    },
    // 球动画 start---------------------------------------
    ballStart() {
      var i = 0;
      var oTag = null;

      this.oDiv = document.getElementById("div1");

      this.aA = this.oDiv.getElementsByTagName("a");

      for (i = 0; i < this.aA.length; i++) {
        // var colors = [
        //   "#FF60AF",
        //   "#9F35FF",
        //   "#FF2D2D",
        //   "#6C6C6C",
        //   "#003D79",
        //   "#00AEAE",
        //   "#019858",
        // ];
        // var rand = Math.ceil(Math.random() * 6);
        // this.aA[i].style.color = colors[rand];

        oTag = {};

        oTag.offsetWidth = this.aA[i].offsetWidth;
        oTag.offsetHeight = this.aA[i].offsetHeight;

        this.mcList.push(oTag);
      }

      this.sineCosine(0, 0, 0);

      this.positionAll();

      let that = this

      this.oDiv.ontouchstart = function () {
        // console.log('mousedown执行了')
        that.active = false;
      };
      this.oDiv.ontouchend = function () {
        // console.log('mouseup执行了')
        // that.active = false;
        that.clxHuifu()
      };
      this.oDiv.ontouchmove = function (ev) {
        that.active = true;
        var oEvent = window.event || ev;

        that.mouseX = oEvent.changedTouches[0].clientX - (that.oDiv.offsetLeft + that.oDiv.offsetWidth / 2);
        that.mouseY = oEvent.changedTouches[0].clientY - (that.oDiv.offsetTop + that.oDiv.offsetHeight / 2);

        that.mouseX /= 2;
        that.mouseY /= 2;
      };

      setInterval(this.update, 10);
    },
    clxHuifu() {
      setTimeout(() => {
        this.active = true;
      }, 1000);
      let timerX = setInterval(() => {
        if (this.mouseX <= -8) {
          this.mouseX = -8
          clearInterval(timerX)
        } else {
          this.mouseX -= 8
        }
      }, 10);
      let timerY = setInterval(() => {
        if (this.mouseY <= -8) {
          this.mouseY = 8
          clearInterval(timerY)
        } else {
          this.mouseY -= 1
        }
      }, 10);
    },
    update() {
      var a;
      var b;

      if (this.active) {
        a = (-Math.min(Math.max(-this.mouseY, -this.size), this.size) / this.radius) * this.tspeed;
        b = (Math.min(Math.max(-this.mouseX, -this.size), this.size) / this.radius) * this.tspeed;
      } else {
        a = this.lasta * 0.98;
        b = this.lastb * 0.98;
      }

      this.lasta = a;
      this.lastb = b;

      if (Math.abs(a) <= 0.01 && Math.abs(b) <= 0.01) {
        return;
      }

      var c = 0;
      this.sineCosine(a, b, c);
      for (var j = 0; j < this.mcList.length; j++) {
        var rx1 = this.mcList[j].cx;
        var ry1 = this.mcList[j].cy * this.ca + this.mcList[j].cz * -this.sa;
        var rz1 = this.mcList[j].cy * this.sa + this.mcList[j].cz * this.ca;

        var rx2 = rx1 * this.cb + rz1 * this.sb;
        var ry2 = ry1;
        var rz2 = rx1 * -this.sb + rz1 * this.cb;

        var rx3 = rx2 * this.cc + ry2 * -this.sc;
        var ry3 = rx2 * this.sc + ry2 * this.cc;
        var rz3 = rz2;

        this.mcList[j].cx = rx3;
        this.mcList[j].cy = ry3;
        this.mcList[j].cz = rz3;

        let per = this.d / (this.d + rz3);

        this.mcList[j].x = this.howElliptical * rx3 * per - this.howElliptical * 2;
        this.mcList[j].y = ry3 * per;
        this.mcList[j].scale = per;
        this.mcList[j].alpha = per;

        this.mcList[j].alpha = (this.mcList[j].alpha - 0.6) * (10 / 6);
      }

      this.doPosition();
      this.depthSort();
    },
    depthSort() {
      var i = 0;
      var aTmp = [];

      for (i = 0; i < this.aA.length; i++) {
        aTmp.push(this.aA[i]);
      }

      aTmp.sort(function (vItem1, vItem2) {
        if (vItem1.cz > vItem2.cz) {
          return -1;
        } else if (vItem1.cz < vItem2.cz) {
          return 1;
        } else {
          return 0;
        }
      });

      for (i = 0; i < aTmp.length; i++) {
        aTmp[i].style.zIndex = i;
      }
    },
    positionAll() {
      var phi = 0;
      var theta = 0;
      var max = this.mcList.length; //总数量
      console.log(max)
      var i = 0;

      var aTmp = [];
      var oFragment = document.createDocumentFragment();

      //随机排序
      for (i = 0; i < this.aA.length; i++) {
        aTmp.push(this.aA[i]);
      }

      aTmp.sort(function () {
        return Math.random() < 0.5 ? 1 : -1;
      });

      for (i = 0; i < aTmp.length; i++) {
        oFragment.appendChild(aTmp[i]);
      }

      this.oDiv.appendChild(oFragment);

      for (var i = 1; i < max + 1; i++) {
        if (this.distr) {
          phi = Math.acos(-1 + (2 * i - 1) / max);
          theta = Math.sqrt(max * Math.PI) * phi;
        } else {
          phi = Math.random() * Math.PI;
          theta = Math.random() * (2 * Math.PI);
        }
        //坐标变换
        this.mcList[i - 1].cx = this.radius * Math.cos(theta) * Math.sin(phi);
        this.mcList[i - 1].cy = this.radius * Math.sin(theta) * Math.sin(phi);
        this.mcList[i - 1].cz = this.radius * Math.cos(phi);

        // this.aA[i - 1].style.left =
        //   this.mcList[i - 1].cx +
        //   this.oDiv.offsetWidth / 2 -
        //   this.mcList[i - 1].offsetWidth / 2 +
        //   "px";
        // this.aA[i - 1].style.top =
        //   this.mcList[i - 1].cy +
        //   this.oDiv.offsetHeight / 2 -
        //   this.mcList[i - 1].offsetHeight / 2 +
        //   "px";
      }
    },
    doPosition() {
      var l = this.oDiv.offsetWidth / 2;
      var t = this.oDiv.offsetHeight / 2;
      for (var i = 0; i < this.mcList.length; i++) {
        this.aA[i].style.left = this.mcList[i].cx + l - this.mcList[i].offsetWidth / 2 + "px";
        this.aA[i].style.top = this.mcList[i].cy + t - this.mcList[i].offsetHeight / 2 + "px";

        // this.aA[i].style.fontSize = Math.ceil((12 * this.mcList[i].scale) / 2) + 100 + "rpx";

        this.aA[i].style.filter = "alpha(opacity=" + 100 * this.mcList[i].alpha + ")";
        this.aA[i].style.opacity = this.mcList[i].alpha;
      }
    },
    sineCosine(a, b, c) {
      this.sa = Math.sin(a * this.dtr);
      this.ca = Math.cos(a * this.dtr);
      this.sb = Math.sin(b * this.dtr);
      this.cb = Math.cos(b * this.dtr);
      this.sc = Math.sin(c * this.dtr);
      this.cc = Math.cos(c * this.dtr);
    },
    // 球动画 end---------------------------------------
  },
  mounted() {
    this.ballStart()
  },
}
</script>

<style lang="less">
#div1 {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

#div1 a {
  position: absolute;
  top: 0px;
  left: 0px;
  padding: 0.14rem 0.3rem;
  border-radius: 0.27rem;
  background-color: #2CA9AA;
  color: #fff;
  text-decoration: none;
  font-size: 0.25rem;
  line-height: 0.18rem;
  white-space: nowrap;
}
// #div1 a:nth-child(even){
// 	position: absolute;
// 	top: 0px;
// 	left: 0px;
// 	padding: 0.15rem 0.25rem;
// 	border-radius: 0.25rem;
// 	background-color: #2CA9AA;
// 	color: #fff;
// 	text-decoration: none;
// 	font-size: 0.21rem;
// 	line-height: 0.18rem;
// 	white-space: nowrap;
// }

</style>